/* eslint-disable standard/object-curly-even-spacing */
import api from '../../../services/service_pos'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import apiCus from '../../../services/service_customer'
import moment from 'moment'
import apiCalendar from '../../../services/service_calendar'

export default {
  props: ['host'],
  components: {
    Multiselect
  },
  data () {
    return {
      payment_amount: 0,
      customer_data: [],
      customer: '',
      isDisabled: false,
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      description: '',
      calendar_time: moment(new Date()),
      calendar_description: ''
    }
  },
  methods: {
    moment,
    customSearch ({ ar_code, cus_name}) {
      return `${ar_code}: ${cus_name}`
    },
    PaymentProcessCard () {
      if (this.$store.state.order_data.id) {
        if (this.customer.ar_code !== undefined) {
          this.$store.state.order_data.credit_card_amount = parseFloat(
            this.payment_amount
          )
          this.$store.state.order_data.cash_amount = 0
          this.checkOutUpdate()
        } else {
          Swal.fire('กรุณาเลือกลูกหนี้', '', 'warning')
        }
      } else {
        if (this.customer.ar_code !== undefined) {
          this.$store.state.order_data.credit_card_amount = parseFloat(
            this.payment_amount
          )
          this.$store.state.order_data.cash_amount = 0
          this.checkOut()
        } else {
          Swal.fire('กรุณาเลือกลูกหนี้', '', 'warning')
        }
      }
    },
    checkOutUpdate () {
      console.log("payment credit 59")
      let change_amount =
        this.payment_amount -
        (this.$store.state.order_data.item_amount -
          this.$store.state.order_data.discount_amount)
      $('#PaymentModal').modal('hide')
      if (parseFloat(this.payment_amount) >= 0) {
        this.$store.commit('Loading')
        this.$store.state.order_data.bill_type = 1
        this.$store.state.order_data.ar_code = this.customer.ar_code
        api.UpdateSale(
          this.REST_URL,
          this.$store.state.order_data,
          this.header,
          result => {
            if (result.response === 'success') {
              this.addCalendar({
                id: 0,
                title: this.calendar_description,
                start: this.calendar_time
              })
              this.$store.commit('clearOrderPayment')
              $('body').on('hidden.bs.modal', '.modal', function () {
                console.clear()
                $(this).removeData('bs.modal')
              })
              Swal.fire({
                title: 'บันทึกรายการขายเชื่อสำเร็จ',
                text:
                  result.data && result.data.doc_no
                    ? 'เลขที่ ' + result.data.doc_no + ' ทำรายการเรียบร้อยแล้ว'
                    : 'ทำรายการเรียบร้อยแล้ว',
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ปิดหน้าต่าง'
              })
            } else {
              this.$notification['warning']({
                message: 'สร้างใบเสร็จไม่ได้',
                description: result.message
              })
              $('body').on('hidden.bs.modal', '.modal', function () {
                console.clear()
                $(this).removeData('bs.modal')
              })
            }
            this.$store.commit('Loading')
          },
          error => {
            alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            this.$store.commit('Loading')
            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
          }
        )
      }
    },
    checkOut () {
      console.log("payment credit 128")
      let change_amount =
        this.payment_amount -
        (this.$store.state.order_data.item_amount -
          this.$store.state.order_data.discount_amount)
      $('#PaymentModal').modal('hide')
      if (parseFloat(this.payment_amount) >= 0) {
        this.$store.commit('Loading')
        this.$store.state.order_data.host_code = this.host.host_code
        this.$store.state.order_data.shift_id = parseFloat(this.host.id)
        this.$store.state.order_data.bill_type = 1
        this.$store.state.order_data.ar_code = this.customer.ar_code
        this.$store.state.order_data.cust_description = ''
        this.$store.state.order_data.description = this.description
        this.$store.state.order_data.calendar_time = moment(
          this.calendar_time
        ).format('YYYY-MM-DD HH:mm:ss')
        this.$store.state.order_data.calendar_time = ''
        this.$store.state.order_data.calendar_description = this.calendar_description
        api.addSale(
          this.REST_URL,
          this.$store.state.order_data,
          this.header,
          result => {
            if (result.response === 'success') {
              this.addCalendar({
                id: 0,
                title: this.calendar_description,
                start: this.calendar_time
              })
              this.$store.commit('clearOrderPayment')
              this.openCashBox(this.host)
              $('body').on('hidden.bs.modal', '.modal', function () {
                console.clear()
                $(this).removeData('bs.modal')
              })
              Swal.fire({
                title: 'บันทึกรายการขายเชื่อสำเร็จ',
                text:
                  result.data && result.data.doc_no
                    ? 'เลขที่ ' + result.data.doc_no + ' ทำรายการเรียบร้อยแล้ว'
                    : 'ทำรายการเรียบร้อยแล้ว',
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'ปิดหน้าต่าง'
              })
            } else {
              this.$notification['warning']({
                message: 'สร้างใบเสร็จไม่ได้',
                description: result.message
              })
              $('body').on('hidden.bs.modal', '.modal', function () {
                console.clear()
                $(this).removeData('bs.modal')
              })
            }
            this.$store.commit('Loading')
          },
          error => {
            alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            this.$store.commit('Loading')
            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
          }
        )
      }
    },
    printBill (docNo) {
      var obj = {
        printer_port: this.host.printer_port,
        doc_no: docNo
      }
      this.$store.commit('Loading')
      api.printBillCredit(
        this.REST_URL,
        obj,
        this.header,
        result => {
          if (result.response === 'success') {
            this.$notification['success']({
              message: 'พิมพ์ใบเสร็จสำเร็จ',
              description: result.message
            })
            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
          } else {
            this.$notification['warning']({
              message: 'พิมพ์ใบเสร็จไม่ได้',
              description: result.message
            })
            $('body').on('hidden.bs.modal', '.modal', function () {
              console.clear()
              $(this).removeData('bs.modal')
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
          $('body').on('hidden.bs.modal', '.modal', function () {
            console.clear()
            $(this).removeData('bs.modal')
          })
        }
      )
    },
    getCustomer () {
      this.$store.commit('Loading')
      let body = {
        keyword: '',
        limit: 1000000,
        status: 1
      }
      apiCus.listAll(
        this.REST_URL,
        this.header,
        body,
        result => {
          if (result.response === 'success') {
            this.customer_data = []
            result.data.forEach(val => {
              this.customer_data.push({
                cus_name: val['name'],
                ar_code: val['code']
              })
              if (this.$store.state.order_data.holding_status === 1) {
                if (this.$store.state.order_data.ar_code === val['code']) {
                  this.customer = {
                    cus_name: val['name'],
                    ar_code: val['code']
                  }
                }
              } else {
                this.customer = ''
                if (this.$refs.cusAuto) {
                  this.$refs.cusAuto.inputValue = ''
                }
              }
            })
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลลูกหนี้',
              description: result.message
            })
          }
          this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    },
    addCalendar (data) {
      if (data.title !== '') {
        const obj = {
          id: data.id,
          title: data.title,
          start: moment(data.start).format('YYYY-MM-DD HH:mm:ss'),
          color: 'yellow',
          all_day: false
        }
        if (obj.id === 0) {
          obj.status = 0
        } else {
          obj.status = 1
        }
        apiCalendar.new(
          this.REST_URL,
          {
            headers: {
              'Access-Token': sessionStorage.token
            }
          },
          obj,
          result => {
            if (result.response === 'success') {
              this.$notification['success']({
                message: 'ข้อมูลการนัดหมาย',
                description: 'จัดการข้อมูลการนัดหมายสำเร็จ!!'
              })
            } else {
              this.$notification['warning']({
                message: 'จัดการข้อมูลปฎิทิน',
                description: result.message
              })
            }
          },
          error => {
            alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          }
        )
      } else {
        this.$notification['warning']({
          message: 'เพิ่มข้อมูลปฎิทิน',
          description: 'ไม่มีข้อมูล'
        })
      }
    }
  },
  mounted () {
    this.getCustomer()
    $('#PaymentModal').on(
      'show.bs.modal',
      function () {
        this.getCustomer()
      }.bind(this)
    )
    $('#PaymentModal').on(
      'hidden.bs.modal',
      function () {
        this.payment_amount = 0
        this.customer = ''
      }.bind(this)
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/paymentcredit.js